import React from 'react';
import Modal from '../shared/Modal';
import FormsyInput from '../form/FormsyInput';
import FormsyCheckbox from '../form/FormsyCheckbox';
import Formsy from 'formsy-react';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import withSplashMessage from '../splashMessage/withSplashMessage';

class MenuDuplicateModal extends React.Component {
  state = {
    new_name: '',
    copy_to_occasion: false
  };

  render() {
    const { handleChange, submitCreate } = this;
    const { isOpen, closeModal } = this.props;
    const { new_name, copy_to_occasion } = this.state;

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="modal modal--no-padding"
      >
        <div className="modal__head">
          <div className="modal__section">
            <h2 className="h2 modal__heading">Copy Menu</h2>
          </div>

          <Formsy className="form" onValidSubmit={submitCreate}>
            <FormsyInput
              type="text"
              name="new_name"
              placeholder="Menu Name"
              value={new_name}
              onChange={handleChange}
              autoComplete="off"
              required
            />

           {this.isGrantedToCopyToOccasion() && <div className="form__row">
              <div className="checkbox-group">
                <FormsyCheckbox
                  name="copy_to_occasion"
                  checked={copy_to_occasion}
                  placeholder="Copy to Occasion Menu"
                  className="checkbox--small checkbox--small-blue checkbox--inline"
                  onChange={handleChange}
                />
              </div>
            </div>}

            <div className="row">
              <div className="row__item row__item--half">
                <div
                  className="btn btn--hollow-red-bright btn--full-width"
                  onClick={closeModal}
                >
                  Cancel
                </div>
              </div>
              <div className="row__item row__item--half">
                <input
                  type="submit"
                  value="Confirm"
                  className="btn btn--solid-blue btn--full-width"
                />
              </div>
            </div>
          </Formsy>
        </div>
      </Modal>
    );
  }

  submitCreate = () => {
    const menu = { ...this.props.menu };
    menu.id = null;
    this.state.copy_to_occasion && (menu.occurrence = 'occasion')
    menu.status = (['weekly','evergreen'].includes(menu.occurrence)) ? 'drafted' : null;
    menu.name = this.state.new_name;
    menu.courses = menu.courses.map(course => {
      course.id = null;
      return course;
    });
    menu.service_week = null;

    menuAPI
      .createMenu(menu)
      .then(menu => {
        this.props.closeModal({ menu, redirect_to: `/admin/menu/${menu.id}` });
        this.props.addMessage({
          className: 'success',
          message: `You created a menu named '${menu.name}'`
        });
      })
      .catch(error => console.log(error)); //todo: what happens?
  };

  isGrantedToCopyToOccasion() {
    return this.props.menu.occurrence === 'company';
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  deriveState() {
    return { new_name: `${this.props.menu.name} Copy` };
  }

  componentDidMount() {
    // initialize state from props
    const state = this.deriveState();
    this.setState(state);
  }

  componentDidUpdate(prevProps) {
    // update state from props
    if (this.props.menu !== prevProps.menu) {
      const state = this.deriveState();
      this.setState(state);
    }
  }
}

export default withSplashMessage(MenuDuplicateModal);



// WEBPACK FOOTER //
// ./src/components/menu/MenuDuplicateModal.js